import { Component, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TypeObjetMaquette } from '@pcscol/odf-api-v1-angular';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, map, takeUntil, tap } from 'rxjs/operators';
import { ObjetMaquette } from '../models/objet-maquette.model';
import { EspaceService } from '../services/espace.service';
import { TreeViewService } from '../services/tree-view.service';
import { TreeNode } from './treeview/tree-node';
import { Title } from '@angular/platform-browser';
import { ToolboxComponent } from './toolbox/toolbox.component';
import { MatDrawerContainer, MatDrawerContent, MatDrawer } from '@angular/material/sidenav';
import { TreeviewComponent } from './treeview/treeview.component';
import { GraphComponent } from './graph/graph.component';
import { SidebarComponent } from './sidebar/sidebar/sidebar.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-editeur',
    templateUrl: './editeur.component.html',
    styleUrls: ['./editeur.component.scss'],
    imports: [
        ToolboxComponent,
        MatDrawerContainer,
        MatDrawerContent,
        TreeviewComponent,
        GraphComponent,
        MatDrawer,
        SidebarComponent,
        AsyncPipe
    ]
})
export class EditeurComponent implements OnDestroy {
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private treeView = inject(TreeViewService);
    private espaceService = inject(EspaceService);
    private title = inject(Title);

    racine$ = this.treeView.racineMaquette$.asObservable().pipe(
        tap(r => {
            this.title.setTitle((r?.code ? `Maquette ${r?.code} | ` : '') + 'Editeur | ODF | Pégase');
        })
    );
    espace$ = this.espaceService.espaceSelected$;

    private destroyed$ = new Subject<boolean>();
    viewLayout$ = this.treeView.viewLayout$;
    sidebarOpened$ = this.treeView.sidebarOpened$;

    constructor() {
        this.route.paramMap
            .pipe(
                map(params => params.get('id') ?? null),
                distinctUntilChanged(),
                tap((id: string | null) => {
                    this.objetMaquetteSelected(null);
                    this.treeView.racineMaquetteId = id;
                }),
                takeUntil(this.destroyed$)
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.treeView.lancerRechercheTexte(null);
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }

    // Objet maquette sélectionné dans le treeView
    objetMaquetteSelected(noeud: TreeNode | null) {
        this.treeView.selectObjetMaquette(noeud);
    }

    objetMaquetteCree(om: ObjetMaquette) {
        if (this.racine$ == null) {
            // si l'éditeur n'affiche aucune arborescence, alors on recharge l'éditeur pour afficher l'arborescence à partir de l'om créé
            this.changerRacine(om.id);
        }
    }

    private changerRacine(id?: string) {
        this.router.navigate([id], { relativeTo: this.route });
    }

    get racineEstUneFormation$(): Observable<boolean> {
        return this.racine$.pipe(map(r => r?.typeObjetMaquette === TypeObjetMaquette.Formation));
    }
}
